<div class="form-group">
  @if (label) {
    <label [for]="id">{{ label }}</label>
  }
  <input [type]="type" [id]="id" [name]="name" [placeholder]="placeholder" [required]="required" [disabled]="disabled"
    [readonly]="readonly" [minlength]="minlength" [maxlength]="maxlength" [attr.pattern]="pattern" [min]="min" [max]="max"
    [step]="step" [autocomplete]="autocomplete" [(ngModel)]="value" (ngModelChange)="onChange($event)"
    (blur)="onTouched()" class="form-control" [ngClass]="{ 'is-invalid': control.touched && control.errors }" />
  @if (control.touched && control.errors) {
    <div class="invalid-feedback">
      {{ getErrorMessage() }}
    </div>
  }
</div>